import { AgiSalesBrandConfig } from './brands/agisales.config';

export interface BrandConfig {
  appName: string;
  companyName: string;
  logoUrl: string;
  favicon: string;
  theme: {
    primary: string;
    secondary: string;
    success: string;
    error: string;
    warning: string;
    info: string;
    background: string;
    text: string;
    border: string;
  };
  meta: {
    title: string;
    description: string;
    keywords: string;
  };
  menu: {
    showNotifications: boolean;
    notificationCount: number;
    showUserAvatar: boolean;
    avatarBgColor: string;
    avatarTextColor: string;
  };
  defaultUser: {
    name: string;
    initials: string;
  };
}

export const BRAND_CONFIG: BrandConfig = AgiSalesBrandConfig;
